import script from "./MacroAnalysis.vue?vue&type=script&lang=ts&setup=true"
export * from "./MacroAnalysis.vue?vue&type=script&lang=ts&setup=true"

import "./MacroAnalysis.vue?vue&type=style&index=0&id=b88bacf2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b88bacf2"]])

export default __exports__